export interface Role {
  id: string;
  name: string;
  description: string;
  showSettings: string;
  canEdit: boolean;
  canDelete: boolean;
}
